export default __webpack_public_path__ + "static/media/py.e403ac55.svg";